// src/features/employee/EmployeePayslip.js
import React from "react";
import "../client/AddClient.css";
import { IoPersonSharp } from "react-icons/io5";


const EmployeePayslip = ({ employeeId }) => {
  return (
    <div className="add-client-form">
      <div style={{ display: "flex", gap: "30px", alignItems: "flex-start" }}>
        {/* Left Section - Form Fields */}
        <div style={{ flex: 1 }}>
          {/* Employee Details Section */}
          <div className="form-section">
            <h3>
              <span className="icon"><IoPersonSharp />
</span> Employee Details
            </h3>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
              <div className="input-group">
                <label>Employee Name</label>
                <input type="text" />
              </div>
              <div className="input-group">
                <label>Shift</label>
                <input type="text" />
              </div>
              <div className="input-group">
                <label>Employee Key</label>
                <input type="text" />
              </div>
              <div className="input-group">
                <label>Paid Days</label>
                <input type="text" />
              </div>
              <div className="input-group">
                <label>Mobile Number</label>
                <input type="text" />
              </div>
              <div className="input-group">
                <label>LOP Days</label>
                <input type="text" />
              </div>
            </div>
          </div>

          {/* Salary Details Section */}
          <div className="form-section">
            <h3>
              <span className="icon"><IoPersonSharp />
</span> Salary Details
            </h3>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "20px" }}>
              <div className="input-group">
                <label>Job Role</label>
                <input type="text" />
              </div>
              <div className="input-group">
                <label>Salary</label>
                <input type="text" />
              </div>
              <div className="input-group">
                <label>Band</label>
                <input type="text" />
              </div>
            </div>
          </div>

          {/* Components Section */}
          <div className="form-section">
            <h3>Components</h3>
            <table className="salary-table" style={{ width: "100%", tableLayout: "fixed" }}>
              <thead>
                <tr>
                  <th style={{ width: "33.33%" }}>Component Name</th>
                  <th style={{ textAlign: "center", width: "33.33%" }}>Component Type</th>
                  <th style={{ textAlign: "right", width: "33.33%" }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Basic pay</td>
                  <td style={{ textAlign: "center" }}>Allowance</td>
                  <td style={{ textAlign: "right" }}>5000</td>
                </tr>
                <tr>
                  <td>Rent allowance</td>
                  <td style={{ textAlign: "center" }}>Allowance</td>
                  <td style={{ textAlign: "right" }}>2000</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Right Section - Net Payable Card */}
        <div
          style={{
            backgroundColor: "#2b3667",
            borderRadius: "25px 0px 0px 25px",
            padding: "70px 40px",
            color: "#fff",
            minWidth: "275px",
            textAlign: "center",
            boxShadow: "0 4px 12px rgba(0,0,0,2.08)",
            marginTop: "60px",
            height: "60px",
          }}
        >
          <div
            style={{
              fontSize: "18px",
              
              marginBottom: "20px",
              fontWeight: "400",
              opacity: "0.9",
              margintop: "-11px",
              letterSpacing: "0.5px",
              marginleft: "-200px",
              margintop: "-30px",

            
            }}
          >
            Net Payable
          </div>
          <div
            style={{
              fontSize: "64px",
              fontWeight: "700",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              lineHeight: "1",
              letterSpacing: "-1px",
              marginTop:"-25px",
            }}
          >
            <span
              style={{
                fontSize: "40px",
                marginRight: "10px",
                marginTop: "15px",
                fontWeight: "400",
                margintop: "-5px",
              }}
            >
              ₹
            </span>
            9000
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeePayslip;
